export default {
    AMBULATORIO: 'ambulatorio',
    FARMACIA: 'farmacia',
    IMUNIZACAO: 'imunizacao',
    PAINEL_SENHA: 'painel-senha',
    PRONTO_ATENDIMENTO: 'pronto-atendimento',
}